export default "__VITE_ASSET__6fac7524__"